<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.ip_whitelist") }}
    //- .section-header-breadcrumb
    //-   .breadcrumb-item.active
    //-     router-link(to="/account/memberList") {{ $t("ui.member_list") }}
    //-   .breadcrumb-item
    //-     a(href='#') Components
    //-   .breadcrumb-item Statistic
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.ip") }}
                  DebounceInput(required autofocus type="text" size="sm" v-model="search" :placeholder="$t('message.search_by_id')" @enter="getIpWhitelist(true)")
              .form-group.col-9
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getIpWhitelist(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12
                b-button(v-b-modal.addIpWhitelist type="button" variant="info" size="sm").mr-3
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_ip_whitelist") }}
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12 
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        //- th.sortable(width="11%" @click="sortOrder('account_id')")
                        //-   span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        //-   i(:class="changeSortKey('account_id')")
                        th(width="23%")
                          span(:title="$t('ui.ip_address')") {{ $t("ui.ip_address") }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.action')") {{ $t("ui.action") }}
                        th.text-right.sortable(width="12%" @click="sortOrder('created_date')")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                          i(:class="changeSortKey('created_date')")
                    tbody.clusterize-content
                      tr(v-if="ipList.length == 0")
                        td(:colspan="5").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in ipList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        //- td
                        //-   span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="item.ip_address") {{ item.ip_address }}
                        td.actions.text-center
                          span
                            a.fa.fa-trash.text-danger(href="javascript:void(0)" @click="onDelete(item)" :title="$t('ui.delete')")
                        td.text-right
                          span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    addipwhitelist(@clicked="addIpWhitelist" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addipwhitelist from "@/components/operator/addIpWhitelist.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import OperatorLookup from "@/library/OperatorLookup";

export default {
  components: {
    addipwhitelist,
    SubmitButton,
    DebounceInput,
    OperatorLookup
  },
  data: () => ({
    loading: false,
    ipList: [],
    currentPage: 1,
    totalRow: 0,
    search: "",
    account_id: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "account_id",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountID() {
      return this.$store.getters.accountId
    },
  },
  mounted: function() {
    this.getIpWhitelist(true);
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getIpWhitelist(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getIpWhitelist: function(isSearch) {
      let url = config.ipWhitelistListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      if (this.search.trim() != '')
        json.ip_address = this.search;

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ipList = response.data.dt;
                this.totalRow = this.ipList.length > 0 ? this.ipList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getIpWhitelist(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getIpWhitelist();
    },
    onDelete: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.delete_ip_address_confirm", { ip: item.ip_address, name: this.accountID }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmDelete(item);
          }
        });
    },
    confirmDelete: function(item) {
      let url = config.ipWhitelistDeleteUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ip_address: item.ip_address
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getIpWhitelist();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addIpWhitelist: function() {
      this.search = "";
      this.currentPage = 1;
      this.getIpWhitelist(true);

      this.$helpers.showDialog(this.$t("ui.combine.add_ip_whitelist"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>